<script lang="ts">
  export let size = 60;
  export let color = "var(--rk-divider-0)";
</script>

<div style:width="{size}px" style:height="{size}px" style:color>
  <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5031 22C12.9087 28.5333 11.392 35.5333 9.95312 43H50.3198L49.2115 37.6917C48.8635 36.0681 48.3235 33.6375 47.5913 30.3999H43C41.8954 30.3999 41 29.5045 41 28.3999V24.3999H35C33.8954 24.3999 33 23.5045 33 22.3999V13.3999C33 12.2953 33.8954 11.3999 35 11.3999H39.6006C38.7599 10.7097 37.8608 10.1208 36.9031 9.63333C34.7642 8.54444 32.5087 8 30.1365 8C26.5198 8 23.2726 9.225 20.3948 11.675C17.5559 14.125 15.592 17.5667 14.5031 22ZM25.4698 51.4C26.7531 52.6444 28.3087 53.2667 30.1365 53.2667C31.9642 53.2667 33.5003 52.6444 34.7448 51.4C36.0281 50.1167 36.6698 48.5611 36.6698 46.7333H23.6031C23.6031 48.5611 24.2253 50.1167 25.4698 51.4Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.5 20.1193H38.3758C38.4045 20.1001 38.4267 20.0744 38.4469 20.051C38.4562 20.0402 38.4651 20.0299 38.4739 20.0211L42.3457 15.8947V14H35.6543V15.8807H39.512C39.4974 15.8953 39.4828 15.9082 39.4688 15.9206C39.4424 15.944 39.4181 15.9655 39.3998 15.993L35.5 20.1193V22H42.5V20.1193ZM43.4219 26.0396V27.9961H52.6339V25.9575H46.4319C46.5999 25.7797 46.7679 25.5881 46.9499 25.3692L52.3819 18.8705V16.9961H43.6879V19.021H49.3299C49.2149 19.1435 49.1 19.2813 48.9676 19.44C48.9226 19.4939 48.8756 19.5503 48.8259 19.6093L43.4219 26.0396Z"
      fill="currentColor"
    />
  </svg>
</div>

<style>
  svg {
    width: 100%;
    height: auto;
  }
</style>
